<template>
<a :href="'../work/?id='+lavoro.id">
    <div id="workPreview" :style="'background-image:url(\''+lavoro.imgPreview+'\')'">
        <div class="logoAzienda">
            <img :src="lavoro.logoAzienda" :alt="lavoro.name">
        </div>
    </div>
</a>
</template>
<script>
export default {
    props:['lavoro'],
}
</script>
<style scoped>
#workPreview{
    width: 100%;
    padding-bottom: 100%;
    background-size: cover;
    border-radius: 1rem;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    transition-duration: 0.2s;
}
.logoAzienda{
    width: 80%;
    height: 100%;
    position: absolute;
    left:50%;
    transform: translateX(-50%);
}
.logoAzienda > img{
    position: absolute;
    top:50%;
    left:50%;
    max-width: 100%;
    max-height: 100px;
    transform: translateX(-50%) translateY(-50%);
    backdrop-filter: blur(8px);
    border-radius: 10px;
}
#workPreview:hover{
    transform: scale(1.04);
    transition-duration: 0.2s;
}
</style>